import { time } from '@dr.pogodin/react-utils';

import { getSessions } from 'services/session';

import {
  type PastSessionsT,
  SESSION_PAGE_SIZE,
  type SessionT,
  getId,
  useAsyncData,
  useGlobalState,
} from 'utils';

type UsePastSessionsResT = {
  loadNextPage: (() => void) | null;
  loading: boolean;
  sessions: SessionT[];
};

export function usePastSessions(): UsePastSessionsResT {
  const [userId] = useGlobalState('user.id');

  if (!userId) throw Error('Unauthenticated');

  const e = useAsyncData('pastSessions', async (old): Promise<PastSessionsT> => {
    const page: number = old?.nextPage ?? 0;

    const chunk = await getSessions({ page, userId });

    let data: SessionT[];
    if (old?.data) {
      data = [...old.data];
      const dataMap: Record<string, number> = {};
      for (let i = 0; i < data.length; ++i) {
        dataMap[getId(data[i])] = i;
      }
      for (const item of chunk) {
        const idx = dataMap[getId(item)];
        if (idx) data[idx] = item;
        else data.push(item);
      }
    } else data = chunk;

    return {
      data,
      hasMore: chunk.length === SESSION_PAGE_SIZE,
      nextPage: page + 1,
    };
  }, { maxage: time.YEAR_MS });

  return {
    loadNextPage: !e.loading && e.data?.hasMore ? () => {
      void e.reload();
    } : null,
    loading: e.loading,
    sessions: e.data?.data ?? [],
  };
}
